import React from 'react'
import { ActiveObjectActionsContext, ActiveSelectionContext } from '../active-object-context'
import type { ActiveObjectActions, ActiveSelection } from '../types/active-selection'

/** The selection without live position (see `ActiveSelection`). */
export function useActiveSelection(): ActiveSelection {
  const ctx = React.useContext(ActiveSelectionContext)

  if (!ctx) {
    throw new Error('useActiveSelection must be used within an ActiveObjectProvider')
  }

  return ctx
}

/** Non-throwing variant for components that may render without the provider (tests, storybook). */
export function useActiveSelectionOptional(): ActiveSelection | null {
  return React.useContext(ActiveSelectionContext)
}

/** The selection setters, for a component that writes the selection but doesn't read it. */
export function useActiveObjectActions(): ActiveObjectActions {
  const ctx = React.useContext(ActiveObjectActionsContext)

  if (!ctx) {
    throw new Error('useActiveObjectActions must be used within an ActiveObjectProvider')
  }

  return ctx
}
